// types
import { transactionStatuses } from '../../../@types/unions';

// i18n
import { useTranslation } from 'react-i18next';

// ui
import { BtnLegend } from '../BtnLegend/BtnLegend';
import { ChipStatus } from '../ChipStatus/ChipStatus';

// utils
import { translateStatusDescription } from '../../../utils/translations';

export const BtnLegendTransaction = () => {
	// hooks
	const { t } = useTranslation();

	// vars
	const itemsLegend = transactionStatuses.map((status) => {
		return {
			label: <ChipStatus hasTooltip={false} status={status} />,
			value: translateStatusDescription(status, t),
		};
	});

	return <BtnLegend items={itemsLegend} />;
};
